subscription newCommunication($homeNumberId: ID!, $tz: String) {
  newCommunication(homeNumberId: $homeNumberId) {
    ...on Message {
      __typename
      id
      insertedAt(tz: $tz)
      direction
      canEdit
      involvesCurrentUser
      conversation {
        id
        homeNumber {
          id
          label
          formattedNumber
        }
        teacherPhoneNumber {
          id
          formattedNumber
          displayName
        }
      }
      bodies {
        id
        text
        isCanon
        isOriginal
        homeLanguage {
          id
          name
          language
        }
      }
      moods {
        id
        name
      }
      messageFiles {
        id
        url
        height
        width
      }
      status
    }
    ...on PhoneCall {
      __typename
      id
      insertedAt(tz: $tz)
      direction
      canEdit
      involvesCurrentUser
      conversation {
        id
        homeNumber {
          id
          label
          formattedNumber
        }
        teacherPhoneNumber {
          id
          formattedNumber
          displayName
        }
      }
      notes
      status
    }
  }
}
